<h2 mat-dialog-title>Request for {{ pkg.name }}</h2>
<mat-dialog-content>
  <form class="get-it-now-form" #getItNowForm="ngForm">
    <div>
      <label>To</label>
    </div>
    <div>
      <mat-form-field class="full-width" floatLabel="auto">
        <input matInput placeholder="Name" [value]="salesPerson.formattedName" disabled />
      </mat-form-field>
    </div>
    <div>
      <label>From</label>
    </div>
    <div class="flex-container full-width contact-details">
      <mat-form-field class="flex-item" floatLabel="auto">
        <input
          matInput
          placeholder="First name"
          required
          [(ngModel)]="packageInterest.firstName"
          name="first"
          #firstName="ngModel"
          />
        @if (firstName.invalid) {
          <mat-error>First name is required</mat-error>
        }
      </mat-form-field>
      <mat-form-field class="flex-item" floatLabel="auto">
        <input
          type="email"
          matInput
          placeholder="Email"
          required
          email
          [(ngModel)]="packageInterest.email"
          name="email"
          #email="ngModel"
          />
        @if (email.invalid && email.errors.required) {
          <mat-error>Email is required</mat-error>
        }
        @if (email.invalid && !email.errors.required && email.errors.email) {
          <mat-error>
            Please enter a valid email address
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="full-width" floatLabel="auto">
        <mat-label>Business Name</mat-label>
        <input
          #search
          matInput
          required
          name="businessName"
          autocapitalize="off"
          spellcheck="false"
          [(ngModel)]="businessName"
          />
        @if (!businessName) {
          <mat-error>Business name is required</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="full-width message-container" floatLabel="auto">
        <textarea matInput placeholder="Message" [(ngModel)]="packageInterest.message" name="message"></textarea>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  @if (submitting === true) {
    <div class="submitting">
      <mat-spinner [diameter]="25"></mat-spinner>
    </div>
  } @else {
    <div class="cta get-it-now-button-send">
      <button mat-raised-button (click)="onSubmit()" [disabled]="!getItNowForm.form.valid">SEND</button>
    </div>
  }
</mat-dialog-actions>
